export const useStripe = () => {
  return {
    initPaymentSheet: async () => ({ error: { message: 'El Pago Nativo de Stripe no está disponible en la vista web. Por favor, compila la app en un emulador o dispositivo real para probar pagos.', code: 'Failed' } }),
    presentPaymentSheet: async () => ({ error: { message: 'El Pago Nativo de Stripe no está disponible en la vista web.', code: 'Failed' } }),
  };
};
